/**
 * localStorage key prefix for the one-time first-generation community prompt.
 * Suffixed with the user id so the "already seen" flag is per-account (mirrors
 * the MarketingConsentModal dismissal pattern — no DB column needed).
 */
export const COMMUNITY_PROMPT_SEEN_KEY = "flowly_community_prompt_seen";

/** Where a community CTA was surfaced — the `source` property on every event. */
export type CommunityCtaSource =
  | "payment_success"
  | "first_generation"
  | "profile"
  | "footer"
  | "landing"
  | "floating_button";
